import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-features')!;

export default function ArticleFeaturesPage() {
  return <ArticleTemplate article={article} />;
}